if (!customElements.get('countdown-timer')) {
  customElements.define(
    'countdown-timer',
    class CountdownTimer extends HTMLElement {
      connectedCallback() {
        this.endTime = new Date(this.dataset.end).getTime();
        this.units = {};
        this.querySelectorAll('[data-unit]').forEach((el) => {
          this.units[el.dataset.unit] = el;
        });
        if (Number.isNaN(this.endTime)) return;
        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      tick() {
        let diff = this.endTime - Date.now();
        if (diff <= 0) {
          diff = 0;
          clearInterval(this.interval);
          this.classList.add('countdown--expired');
        }
        const totalSeconds = Math.floor(diff / 1000);
        const values = {
          days: Math.floor(totalSeconds / 86400),
          hours: Math.floor(totalSeconds / 3600) % 24,
          minutes: Math.floor(totalSeconds / 60) % 60,
          seconds: totalSeconds % 60,
        };
        Object.entries(values).forEach(([unit, value]) => {
          if (this.units[unit]) {
            this.units[unit].textContent = String(value).padStart(2, '0');
          }
        });
      }
    }
  );
}

if (!customElements.get('liquidation-hero')) {
  customElements.define(
    'liquidation-hero',
    class LiquidationHero extends HTMLElement {
      connectedCallback() {
        this.NS = 'http://www.w3.org/2000/svg';
        this.querySelectorAll('.lqh-band').forEach((svg) => this.buildRibbon(svg));
        this.querySelectorAll('[data-papel]').forEach((el) => this.buildPapel(el, Number(el.dataset.papel)));
        this.loadConfetti();
      }

      /* woven textile ribbon (stacked chevron bands) */
      buildRibbon(svg) {
        const NS = this.NS;
        const W = 420;
        const H = 64;
        const colors = ['#6f2b9c', '#e23a2a', '#f0801c', '#f5c518', '#16a39b', '#e23a2a'];
        const bandH = H / colors.length;
        const amp = bandH * 0.55;
        const period = 56;
        colors.forEach((c, i) => {
          const y0 = i * bandH;
          const top = [];
          const bot = [];
          for (let x = 0; x <= W + period; x += period / 2) {
            const up = (x / (period / 2)) % 2 === 0;
            top.push([x, y0 + (up ? 0 : amp)]);
            bot.push([x, y0 + bandH + (up ? 0 : amp)]);
          }
          let d = 'M' + top.map((p) => p.join(',')).join(' L ');
          d += ' L ' + bot.reverse().map((p) => p.join(',')).join(' L ') + ' Z';
          const path = document.createElementNS(NS, 'path');
          path.setAttribute('d', d);
          path.setAttribute('fill', c);
          svg.appendChild(path);
          // white weave stitch line
          const st = document.createElementNS(NS, 'path');
          const pts = [];
          for (let x = 0; x <= W + period; x += period / 2) {
            const up = (x / (period / 2)) % 2 === 0;
            pts.push([x, y0 + bandH * 0.5 + (up ? -amp * 0.28 : amp * 0.78)]);
          }
          st.setAttribute('d', 'M' + pts.map((p) => p.join(',')).join(' L '));
          st.setAttribute('fill', 'none');
          st.setAttribute('stroke', 'rgba(255,255,255,.7)');
          st.setAttribute('stroke-width', '1.6');
          st.setAttribute('stroke-dasharray', '2 4');
          svg.appendChild(st);
        });
      }

      /* papel picado (cut-paper banner) */
      buildPapel(el, n) {
        const NS = this.NS;
        const colors = ['#6f2b9c', '#e23a2a', '#f0801c', '#f5c518', '#16a39b', '#e0489c'];
        const hc = (cx, cy, r) => `M${cx - r},${cy} a${r},${r} 0 1,0 ${2 * r},0 a${r},${r} 0 1,0 ${-2 * r},0 Z`;
        const hd = (cx, cy, r) => `M${cx},${cy - r} L${cx + r},${cy} L${cx},${cy + r} L${cx - r},${cy} Z`;
        for (let i = 0; i < n; i++) {
          const svg = document.createElementNS(NS, 'svg');
          svg.setAttribute('viewBox', '0 0 60 64');
          svg.setAttribute('class', 'lqh-flag');
          const d =
            'M4,2 L56,2 L56,46 L30,60 L4,46 Z ' +
            hc(30, 18, 6) + ' ' + hc(17, 31, 2.8) + ' ' + hc(43, 31, 2.8) + ' ' + hd(30, 40, 5);
          const p = document.createElementNS(NS, 'path');
          p.setAttribute('d', d);
          p.setAttribute('fill-rule', 'evenodd');
          p.setAttribute('fill', colors[i % colors.length]);
          svg.appendChild(p);
          svg.style.setProperty('--d', (3.4 + Math.random() * 1.9).toFixed(2) + 's');
          svg.style.animationDelay = (-Math.random() * 3).toFixed(2) + 's';
          el.appendChild(svg);
        }
      }

      loadConfetti() {
        const container = this.querySelector('.lqh-lottie');
        if (!container || !window.lottie) return;
        window.lottie.loadAnimation({
          container,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          path: container.dataset.confettiUrl,
          rendererSettings: { preserveAspectRatio: 'xMidYMid slice' },
        });
      }
    }
  );
}

if (!customElements.get('liquidation-grid')) {
  customElements.define(
    'liquidation-grid',
    class LiquidationGrid extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.baseUrl = (this.dataset.baseUrl || '/collections/all').replace(/\/+$/, '');
        this.allUrl = (this.dataset.allUrl || this.baseUrl).replace(/\/+$/, '');
        this.saleTag = this.dataset.saleTag || '';
        this.currentCollectionUrl = '';
        this.container = this.querySelector('.liquidation-grid__container');
        this.addEventListener('click', this.onClick.bind(this));
        if (this.dataset.initialFetch === 'true') this.fetchProducts(1);
      }

      normalizeUrl(url) {
        return (url || '').replace(/\/+$/, '');
      }

      buildUrl(page) {
        const url = this.currentCollectionUrl || this.allUrl;
        const params = new URLSearchParams();
        if (page > 1) params.set('page', page);
        params.set('section_id', this.sectionId);
        return `${url}?${params.toString()}`;
      }

      onClick(event) {
        const filterButton = event.target.closest('[data-collection-url]');
        if (filterButton) {
          event.preventDefault();
          this.currentCollectionUrl = this.normalizeUrl(filterButton.dataset.collectionUrl);
          this.querySelectorAll('[data-collection-url]').forEach((button) => {
            button.classList.toggle('is-active', button === filterButton);
          });
          this.fetchProducts(1);
          return;
        }

        const paginationLink = event.target.closest('.pagination a');
        if (paginationLink) {
          event.preventDefault();
          const page = new URL(paginationLink.href, window.location.origin).searchParams.get('page') || 1;
          this.fetchProducts(Number(page));
          this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      async fetchProducts(page) {
        this.classList.add('loading');
        try {
          const response = await fetch(this.buildUrl(page));
          if (!response.ok) throw new Error(`Request failed: ${response.status}`);
          const text = await response.text();
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const fresh = doc.querySelector('.liquidation-grid__container');
          if (!fresh) throw new Error('Grid markup not found in response');
          this.container.innerHTML = fresh.innerHTML;
        } catch (error) {
          const fallbackUrl = this.buildUrl(1).split('?')[0];
          window.location.href = fallbackUrl;
        } finally {
          this.classList.remove('loading');
        }
      }
    }
  );
}
